import { Injectable } from '@angular/core';
import {Config} from '@vendor/config/config';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SettingService {

  constructor(private http: HttpClient,
              private config: Config) { }
  logOut(): Observable<any> {
  const param = {};
  const url = this.config.serverUrl + 'api/user/bankLogout';
  return this.http.post(url, param);
  }
  changePass(passObj): Observable<any> {
  const param = passObj;
  const url = this.config.serverUrl + 'api/user/changePassword';
  return this.http.post(url, param);
  }
  editProfile(userObj): Observable<any> {
    const param = userObj;
    const url = this.config.serverUrl + 'api/user/updateProfile';
    return this.http.post(url, param);
  }
  upLoadFile(file): Observable <any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    const url = this.config.serverUrl + 'api/media/upload';
    return this.http.post(url , formData);
  }
  downLoadFile(mediaUniqueId ): Observable <any> {
    const url = this.config.serverUrl + `api/media/${mediaUniqueId}`;
    return this.http.get(url , {});
  }
  getProfileSummery(): Observable <any>  {
    const url = this.config.serverUrl + `api/user/profileSummary`;
    return this.http.get(url , {});
  }
  getUserForms(): Observable<any> {
    const url = this.config.serverUrl + 'api/v1/dynamicForm/user/PROFILE';
    return this.http.get(url, {});
  }
  getSurveyForm(): Observable<any> {
    const url = this.config.serverUrl + 'api/v1/dynamicForm/user/SURVEY';
    return this.http.get(url, {});
  }
  postUserForms(data): Observable<any> {
    const url = this.config.serverUrl + 'api/v1/dynamicForm/user';
    return this.http.post(url, data);
  }

  getActiveDevices(): Observable<any> {
    const url = this.config.serverUrl + `api/user/retrieveActiveSessions`;
    return this.http.get<any>(url, {});
  }
  deleteSession(data): Observable<any> {
    const url = this.config.serverUrl + `api/user/expireSession`;
    return this.http.post<any>(url, data);
  }
  refreshDepostie(data, address): Observable<any> {
    const url = this.config.serverUrl + `api/deposit/${address}/visible`;
    return this.http.post(url, data);
  }
  getTransaction(resourceType, fromDateTimestamp, toDateTimestamp, pageSize, upperBound): Observable<any> {
    let url = this.config.serverUrl + `api/transaction?resourceType=${resourceType}&pageSize=${pageSize}`;
    if (fromDateTimestamp !== '') {
      url += `&fromDateTimestamp=${fromDateTimestamp}`;
    }
    if (toDateTimestamp !== '') {
      url += `&toDateTimestamp=${toDateTimestamp}`;
    }
    if (upperBound !== '') {
      url += `&upperBound=${upperBound}`;
    }
    return this.http.get<any>(url, {});
  }
  getOtherApps(): Observable<any> {
    const url = this.config.serverUrl + 'api/v1/partner/user';
    return this.http.get(url, {});
  }
  requestGetParams(): Observable<any> {
    const url = this.config.serverUrl + 'api/param';
    return this.http.get(url, {});
  }
  checkProfileSummary(): Observable<any> {
    const url = this.config.serverUrl + `api/user/profileSummary`;
    return this.http.get<any>(url, {});
  }
  sendInvitiationCode(param): Observable<any> {
    const url = this.config.serverUrl + `api/user/invitationCode`;
    return this.http.post(url, param);
  }
  getCountTransactionDelete(param): Observable<any> {
    const url = this.config.serverUrl + `api/transaction/users/count`;
    return this.http.request('delete', url, {body: param});
  }
  deleteTransactionsRequest(param): Observable<any> {
    const url = this.config.serverUrl + `api/transaction/users`;
    return this.http.request('delete', url, {body: param});
  }
  changeResourceOrder(param): Observable<any> {
    const url = this.config.serverUrl + `api/v1/resources/orders`;
    return this.http.post(url, param);
  }
  getOwnedCards(): Observable<any> {
    const url = this.config.serverUrl + `api/card/ownedCards`;
    return this.http.get(url, {});
  }
  // user-bill-controller
  getsavedBills(): Observable<any> {
    const url = this.config.serverUrl + 'api/v1/bills/users';
    return this.http.get(url, {});
  }
  deleteBill(billUniqueId): Observable<any> {
    const url = this.config.serverUrl + `api/v1/bills/users/${billUniqueId}`;
    return this.http.delete(url, {});
  }
  addBill(param): Observable<any> {
    const url = this.config.serverUrl + 'api/v1/bills/users';
    return this.http.post(url, param);
  }
  editBill(param, billUniqueId): Observable<any> {
    const url = this.config.serverUrl + `api/v1/bills/users/${billUniqueId}`;
    return this.http.post(url, param);
  }
  // user-topup-controller
  getSavedcharges(): Observable<any> {
    const url = this.config.serverUrl + 'api/v1/topups/users';
    return this.http.get(url, {});
  }
  deleteCharge(topupUniqueId): Observable<any> {
    const url = this.config.serverUrl + `api/v1/topups/users/${topupUniqueId}`;
    return this.http.delete(url, {});
  }
  addCharge(param) {
  const url = this.config.serverUrl + 'api/v1/topups/users';
  return this.http.post(url, param);
  }
  getSuggestionHistory(): Observable<any> {
    const url = this.config.serverUrl + 'api/suggestion/answered';
    return this.http.get(url, {});
  }
  sendSuggestion(data): Observable<any> {
    const url = this.config.serverUrl + 'api/suggestion';
    return this.http.post(url, data);
  }
  serachTransaction(resourceType, fromDateTimestamp, toDateTimestamp, pageSize, upperBound, searchText) {
    let url = this.config.serverUrl + `api/transaction/search?resourceType=${resourceType}&pageSize=${pageSize}&searchText=${searchText}`;
    if (fromDateTimestamp !== '') {
      url += `&fromDateTimestamp=${fromDateTimestamp}`;
    }
    if (toDateTimestamp !== '') {
      url += `&toDateTimestamp=${toDateTimestamp}`;
    }
    if (upperBound !== '') {
      url += `&upperBound=${upperBound}`;
    }
    return this.http.get<any>(url, {});
  }
  changeUserName(param): Observable<any> {
    const url = this.config.serverUrl + 'api/user/changeUsername';
    return this.http.post(url, param);
  }
  // user-package-controller
  getSavedPackage(): Observable<any> {
    const url = this.config.serverUrl + `api/v1/packages/users`;
    return this.http.get(url, {});
  }
  deletePackage(packageUniqueId): Observable<any> {
    const url = this.config.serverUrl + `api/v1/packages/users/${packageUniqueId}`;
    return this.http.delete(url, {});
  }
  addUserPackage(param): Observable<any> {
    const url = this.config.serverUrl + `api/v1/packages/users`;
    return this.http.post<any>(url, param);
  }
  emailSetting(): Observable<any> {
    const url = this.config.serverUrl + `api/user/emailSetting`;
    return this.http.get<any>(url, {});
  }
  changeEmailSetting(param): Observable<any> {
    const url = this.config.serverUrl + `api/user/changeEmailSetting`;
    return this.http.post<any>(url, param);
  }
  getCodeForEmailConfirmation(): Observable<any> {
    const url = this.config.serverUrl + `api/user/getCodeForEmailConfirmation`;
    return this.http.get<any>(url, {});
  }
  validateEmailCode(param): Observable<any> {
    const url = this.config.serverUrl + `api/user/validateEmailCode`;
    return this.http.post<any>(url, param);
  }
}
